import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import CommonButton from "../CommonButton";
import style from "./PromptModal.module.css";
import CommonDescription from "../CommonDescription";

const PromptModal = ({
  title = " Are you sure you want to submit ?",
  onlyButton = false,
  buttonOneLabel = "No",
  buttonTwoLabel = "Yes",
  handleNoClick = () => {},
  handleYesClick = () => {},
  submitHandler = () => {},
  showButton = false,
  isRemark = true,
  okayLabel = "Ok",
  okayButton,
  handleOkayClick = () => {},
}) => {
  const [inputText, setInputText] = useState("");
  const onClickHandler = (inputText) => {
    submitHandler(inputText);
  };
  const inputChangeHandler = (e) => {
    setInputText(e?.target?.value);
  };
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            paddingBottom: "10px",
            paddingTop: "10px",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.6rem",
              fontWeight: "500",
              color: "#505050",
              textAlign: "center",
            }}
          >
            {title}
          </Typography>
        </Grid>
      </Grid>
      {showButton && (
        <div className={style["common_button"]}>
          <div className={style["no_button"]}>
            <CommonButton
              label={buttonOneLabel}
              backgroundColor
              onClick={handleNoClick}
              fitContent={onlyButton}
            />
          </div>
          <div className={style["yes_button"]}>
            <CommonButton
              label={buttonTwoLabel}
              filledButton
              backgroundColor
              onClick={handleYesClick}
              fitContent={onlyButton}
            />
          </div>
        </div>
      )}
      {isRemark && (
        <div style={{ width: "100%" }}>
          <CommonDescription
            minRows={6}
            heading="Remarks"
            placeholder="Enter"
            onChange={inputChangeHandler}
            onSubmitButton={() => onClickHandler(inputText)}
            descriptionVal={inputText}
          />
        </div>
      )}
      {okayButton && (
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <CommonButton
            label={okayLabel}
            filledButton
            backgroundColor
            onClick={handleOkayClick}
            fitContent={onlyButton}
          />
        </div>
      )}
    </>
  );
};

export default PromptModal;
